/* MIRNIX: Recenze zákazníků – Swiper (swipe / tažení myší / šipky) + modal s celou recenzí */
(function () {
	class MxReviews extends HTMLElement {
		connectedCallback() {
			this.initSlider();
			this.initDialogs();
			if (this.dataset.scope === 'product') this.initWriteButton();
			if (this.hasAttribute('data-load-all')) this.loadAll();
		}

		/* Mřížka „všechny recenze“ (stránka Recenze): server vykreslí nejnovější z metafieldu (max. 25),
		   zbytek se dočte z veřejného API Judge.me, které používá jejich widget všech recenzí (CORS povolený,
		   max. 25 na stránku) – produktové recenze i recenze obchodu. Karty = stejný markup jako snippet mx-review-card. */
		async loadAll() {
			const grid = this.querySelector('[data-reviews-grid]');
			const status = this.querySelector('[data-reviews-status]');
			if (!grid || !this.dataset.shop) return;
			const seen = new Set([...grid.querySelectorAll('[data-review-id]')].map((el) => el.dataset.reviewId));
			const shop = encodeURIComponent(this.dataset.shop);
			const base = `https://api.judge.me/reviews/all_reviews_js_based?url=${shop}&shop_domain=${shop}&platform=shopify&per_page=25`;
			const perPage = 25;
			if (status) status.hidden = false;
			try {
				for (const type of ['product-reviews', 'shop-reviews']) {
					for (let page = 1; page <= 40; page++) {
						const response = await fetch(`${base}&page=${page}&review_type=${type}`);
						if (!response.ok) throw new Error(`Judge.me ${response.status}`);
						const data = await response.json();
						const doc = new DOMParser().parseFromString(data.html || '', 'text/html');
						const reviews = [...doc.querySelectorAll('.jdgm-rev[data-review-id]')];
						reviews.forEach((rev) => {
							if (seen.has(rev.dataset.reviewId)) return;
							seen.add(rev.dataset.reviewId);
							grid.append(this.buildCard(rev, grid.children.length + 1));
						});
						if (reviews.length < perPage) break;
					}
				}
				// nejnovější první (data-date = „YYYY-MM-DD HH:MM:SS UTC“ → řazení jako text)
				[...grid.children]
					.sort((a, b) => (b.dataset.date || '').localeCompare(a.dataset.date || ''))
					.forEach((el) => grid.append(el));
				if (status) status.hidden = true;
			} catch (error) {
				console.error(error);
				if (status) status.textContent = this.dataset.i18nError || '';
			}
		}

		buildCard(rev, index) {
			const el = (tag, className, text) => {
				const node = document.createElement(tag);
				if (className) node.className = className;
				if (text) node.textContent = text;
				return node;
			};
			const icon = (name) => {
				const tpl = this.querySelector('template[data-review-icons]');
				const holder = tpl && tpl.content.querySelector(`[data-icon="${name}"]`);
				return holder ? holder.cloneNode(true).firstElementChild || document.createTextNode('') : document.createTextNode('');
			};
			const score = Number(rev.querySelector('[data-score]')?.dataset.score) || 0;
			const author = rev.querySelector('.jdgm-rev__author')?.textContent.trim() || '';
			const datetime = rev.querySelector('.jdgm-rev__timestamp')?.dataset.content || '';
			const [y, m, d] = datetime.slice(0, 10).split('-');
			const date = y ? `${Number(d)}. ${Number(m)}. ${y}` : '';
			const prodLink = rev.querySelector('.jdgm-rev__prod-link');
			const productTitle = (prodLink || rev.querySelector('.jdgm-rev__prod-title'))?.textContent.trim() || '';
			// Judge.me dává relativní /products/… bez jazyka – v EN/SK doplnit /en/, /sk/
			const rawHref = prodLink?.getAttribute('href') || '';
			const productHref = rawHref.startsWith('/') ? (window.Shopify?.routes?.root || '/') + rawHref.slice(1) : rawHref;
			const verified = !!rev.querySelector('.jdgm-rev__buyer-badge');
			const bodyEl = rev.querySelector('.jdgm-rev__body');
			const paragraphs = bodyEl ? [...bodyEl.querySelectorAll('p')].map((p) => p.textContent.trim()).filter(Boolean) : [];
			if (bodyEl && !paragraphs.length && bodyEl.textContent.trim()) paragraphs.push(bodyEl.textContent.trim());
			const bodyLength = paragraphs.join(' ').length;
			const showPhotos = this.dataset.showPhotos === 'true';
			const pics = showPhotos ? [...rev.querySelectorAll('.jdgm-rev__pic-img')].map((img) => img.dataset.src).filter(Boolean) : [];
			const isLong = bodyLength > (Number(this.dataset.clamp) || 200);
			const showProduct = this.dataset.showProduct === 'true' && productTitle;
			const dialogId = `${this.dataset.id}-all-${index}-${rev.dataset.reviewId.slice(0, 8)}`;

			const stars = (withLabel) => {
				const wrap = el('span', 'product-rating mx-review__rating');
				if (withLabel) {
					wrap.setAttribute('role', 'img');
					wrap.setAttribute('aria-label', (this.dataset.i18nRating || '').replace('__RATING__', score));
				} else {
					wrap.setAttribute('aria-hidden', 'true');
				}
				const starsEl = el('span', 'product-rating__stars');
				starsEl.style.setProperty('--rating', `${score * 20}%`);
				starsEl.setAttribute('aria-hidden', 'true');
				starsEl.append(el('span', 'product-rating__row'), el('span', 'product-rating__row product-rating__row--fg'));
				wrap.append(starsEl);
				return wrap;
			};
			const meta = () => {
				const p = el('p', 'mx-review__meta');
				p.append(el('span', 'mx-review__author', author));
				if (verified) p.append(el('span', 'mx-review__verified', this.dataset.i18nVerified));
				p.append(el('time', 'mx-review__date', date));
				return p;
			};
			const text = (clamp) => {
				const div = el('div', `mx-review__text${clamp ? ' mx-review__text--clamp' : ''}`);
				paragraphs.forEach((t) => div.append(el('p', '', t)));
				return div;
			};
			const product = (asLink) => {
				// jen odkazy v rámci obchodu (relativní /products/…)
				if (asLink && productHref.startsWith('/')) {
					const a = el('a', 'mx-review__product', productTitle);
					a.href = productHref;
					return a;
				}
				return el('span', 'mx-review__product', productTitle);
			};

			const wrapper = el('div', 'mx-review');
			wrapper.dataset.reviewId = rev.dataset.reviewId;
			wrapper.dataset.date = datetime;
			const card = el('article', 'mx-review__card');
			if (showProduct) card.append(product(true));
			card.append(stars(true), meta(), text(isLong));
			if (pics.length) {
				const photo = el('img', 'mx-review__photo');
				photo.src = pics[0].replace('width=160', 'width=640');
				photo.loading = 'lazy';
				photo.alt = '';
				card.append(photo);
				if (pics.length > 1) {
					const thumbs = el('div', 'mx-review__pics');
					pics.slice(1, 4).forEach((src) => {
						const img = el('img', 'mx-review__pic');
						Object.assign(img, { src, width: 64, height: 64, loading: 'lazy', alt: '' });
						thumbs.append(img);
					});
					card.append(thumbs);
				}
			}
			wrapper.append(card);

			if (isLong || pics.length) {
				const more = el('button', 'button button--simple mx-review__more');
				more.type = 'button';
				more.dataset.reviewOpen = dialogId;
				const moreIcon = el('span', 'button-icon');
				moreIcon.append(icon('more'));
				more.append(moreIcon, el('span', 'button-label', this.dataset.i18nReadMore));
				card.append(more);

				const dialog = el('dialog', 'mx-review__dialog');
				dialog.id = dialogId;
				dialog.setAttribute('aria-label', author);
				const inner = el('div', `mx-review__dialog-inner${pics.length ? ' mx-review__dialog-inner--with-pics' : ''}`);
				const close = el('button', 'mx-review__close');
				close.type = 'button';
				close.setAttribute('data-review-close', '');
				close.setAttribute('aria-label', this.dataset.i18nClose || '');
				close.append(icon('close'));
				inner.append(close);
				if (pics.length) {
					const large = el('div', 'mx-review__dialog-pics');
					pics.slice(0, 6).forEach((src) => {
						const img = el('img', 'mx-review__pic-large');
						Object.assign(img, { src: src.replace('width=160', 'width=1024'), loading: 'lazy', alt: '' });
						large.append(img);
					});
					inner.append(large);
				}
				const body = el('div', 'mx-review__dialog-body');
				if (showProduct) body.append(product(false));
				body.append(stars(false), meta(), text(false));
				inner.append(body);
				dialog.append(inner);
				wrapper.append(dialog);
			}
			return wrapper;
		}

		/* Detail produktu: widget Judge.me zůstává na stránce kvůli formuláři (otevírá se jako modal) a JSON-LD,
		   ale je skrytý; naše tlačítko jen klikne na jeho „Napsat recenzi“. */
		initWriteButton() {
			document.body.classList.add('mx-reviews-product');
			const button = this.querySelector('[data-review-write]');
			if (!button) return;
			const widget = () => document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
			if (!widget()) return;
			button.hidden = false;
			button.addEventListener('click', () => {
				const w = widget();
				const target = w && ([...w.querySelectorAll('button, a')].find((el) => el.classList.contains('jm-action-buttons__button') || el.classList.contains('jdgm-write-rev-link')));
				if (target) target.click();
			});
		}

		initSlider() {
			const slider = this.querySelector('.mx-reviews__slider');
			if (!slider) return;
			const perRow = Number(this.dataset.perRow) || 3;
			const start = () => {
				if (slider.swiper) return;
				new Swiper(slider, {
					slidesPerView: 1.15,
					spaceBetween: 16,
					grabCursor: true,
					keyboard: { enabled: true },
					watchOverflow: true,
					breakpoints: {
						750: { slidesPerView: 2, spaceBetween: 24 },
						990: { slidesPerView: Math.min(perRow, 3), spaceBetween: 32 },
						1200: { slidesPerView: perRow, spaceBetween: 32 }
					},
					navigation: {
						nextEl: this.querySelector('.mx-reviews__nav--next'),
						prevEl: this.querySelector('.mx-reviews__nav--prev')
					}
				});
			};
			if (window.Swiper) start();
			else window.addEventListener('load', start, { once: true });
		}

		initDialogs() {
			this.addEventListener('click', (event) => {
				const opener = event.target.closest('[data-review-open]');
				if (opener) {
					const dialog = document.getElementById(opener.dataset.reviewOpen);
					if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
					return;
				}
				if (event.target.closest('[data-review-close]')) {
					event.target.closest('dialog').close();
					return;
				}
				// klik mimo obsah (na backdrop) zavře
				const dialog = event.target.closest('dialog');
				if (dialog && event.target === dialog) dialog.close();
			});
		}
	}
	if (!customElements.get('mx-reviews')) customElements.define('mx-reviews', MxReviews);
})();
